import { IpaType } from "../../phonemes/ipa";
import { ipaToSynthSymbols } from "../../speak/exact";
import { Say } from "../widgets/Say";

export function Syllabics() {
  return (<>
    <h2>Syllabic consonants</h2>

    built-in:
    <ul>
      <li><Say>[ˈbl̩d]</Say>, <Say>[ˈbl̩ːd]</Say>, <Say>[ˈbld]</Say></li>
      <li><Say>[ˈbɫ̩d]</Say>, <Say>[ˈbɫ̩ːd]</Say>, <Say>[ˈbɫd]</Say></li>
      <li><Say>[ˈbm̩d]</Say>, <Say>[ˈbm̩ːd]</Say>, <Say>[ˈbmd]</Say></li>
      <li><Say>[ˈbn̩d]</Say>, <Say>[ˈbn̩ːd]</Say>, <Say>[ˈbnd]</Say></li>
      <li><Say>[ˈbŋ̩d]</Say>, <Say>[ˈbŋ̩ːd]</Say>, <Say>[ˈbŋd]</Say></li>
      <li><Say>[ˈbr̩d]</Say>, <Say>[ˈbr̩ːd]</Say>, <Say>[ˈbrd]</Say></li>
      <li><Say>[ˈbɹ̩d]</Say>, <Say>[ˈbɹ̩ːd]</Say>, <Say>[ˈbɹd]</Say></li>
    </ul>

    fricatives:
    <ul>
      <li><ShowOne ipa="β" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="f" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="v" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="θ" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="ð" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="s" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="z" c={["b", "t"]} best="-" /></li>
      <li><ShowOne ipa="ʃ" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="ʒ" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="ʂ" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="ʐ" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="ɕ" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="ʑ" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="ç" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="ʝ" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="x" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="ɣ" c={["p", "t"]} /></li>
      <li><ShowOne ipa="χ" c={["p", "t"]} /></li>
      <li><ShowOne ipa="ʁ" c={["p", "t"]} /></li>
      <li><ShowOne ipa="h" c={["p", "t"]} /></li>
      <li><ShowOne ipa="ɬ" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="ɮ" c={["p", "t"]} best="-" /></li>
    </ul>

    plosives:
    <ul>
      <li><ShowOne ipa="p" c={["p", "t"]} /></li>
      <li><ShowOne ipa="b" c={["p", "t"]} /></li>
      <li><ShowOne ipa="t̪" c={["p", "t"]} /></li>
      <li><ShowOne ipa="d̪" c={["p", "t"]} /></li>
      <li><ShowOne ipa="t" c={["p", "t"]} /></li>
      <li><ShowOne ipa="d" c={["p", "t"]} /></li>
      <li><ShowOne ipa="ʈ" c={["p", "t"]} /></li>
      <li><ShowOne ipa="ɖ" c={["p", "t"]} /></li>
      <li><ShowOne ipa="c" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="ɟ" c={["p", "t"]} best="-" /></li>
      <li><ShowOne ipa="k" c={["p", "t"]} /></li>
      <li><ShowOne ipa="ɡ" c={["p", "t"]} /></li>
      <li><ShowOne ipa="q" c={["p", "t"]} /></li>
      <li><ShowOne ipa="ʔ" c={["p", "t"]} /></li>
    </ul>

    nasals:
    <ul>
      <li><ShowOne ipa="m" c={["t", "d"]} /></li>
      <li><ShowOne ipa="n" c={["t", "d"]} /></li>
      <li><ShowOne ipa="ɳ" c={["t", "d"]} badLong="t" /></li>
      <li><ShowOne ipa="ɲ" c={["t", "d"]} badLong="t" /></li>
      <li><ShowOne ipa="ŋ" c={["t", "d"]} /></li>
    </ul>

    approximants:
    <ul>
      <li><ShowOne ipa="ʋ" c={["t", "d"]} /></li>
      <li><ShowOne ipa="w" c={["t", "d"]} best="-" badLong="t" /></li>
      <li><ShowOne ipa="ɹ" c={["t", "d"]} best="-" altSynth="P" /></li>
      <li><ShowOne ipa="j" c={["t", "d"]} best="-" badLong="t" /></li>
      <li><ShowOne ipa="l" c={["t", "d"]} /></li>
      <li><ShowOne ipa="ɫ" c={["t", "d"]} /></li>
      <li><ShowOne ipa="ɭ" c={["t", "d"]} badLong="t" /></li>
      <li><ShowOne ipa="ʎ" c={["t", "d"]} badLong="t" /></li>
    </ul>

    trills:
    <ul>
      <li><ShowOne ipa="r" c={["p", "t"]} /></li>
      <li><ShowOne ipa="r̥" c={["p", "t"]} /></li>
      <li><ShowOne ipa="ʀ" c={["p", "t"]} /></li>
    </ul>
  </>);
}

/** show alternate ways to treat 'ipa' as a syllabic consonant */
function ShowOne(props: {
  ipa: IpaType,      /** syllabic consonant */
  c: [string, string],  /** consonants to bracket syllabic with */
  best?: '-' | '@',  /** whether it sounds best with espeak's syllabic or adding short schwa */
  badLong?: 't',     /** if a long syllabic is bad */
  altSynth?: string  /** when the the synth encoding isn't inconsistent */
}) {
  const { ipa } = props;
  const synth = props.altSynth ?? ipaToSynthSymbols[ipa];
  if (!synth) {
    return <>{ipa} not found</>;
  }

  const [a, z] = props.c;
  const lngColor1 = props.badLong === 't' ? 'red' : "darkgreen";
  const syllColor = props.best === '@' ? 'red' : props.best === '-' ? 'blue' : "darkgreen";
  const lngColor2 = props.badLong === 't' ? 'red' : "darkgreen";
  const schwColor = props.best === '-' ? 'red' : props.best === '@' ? 'blue' : "darkgreen";
  return (<>
    <Say>{`[ˈ${a}${ipa}\u0329${z}]`}</Say>,
    <Say textColor={lngColor1}>{`[ˈ${a}${ipa}\u0329ː${z}]`}</Say> -
    <Say>{`[ˈ${a}${ipa}${z}]`}</Say>,
    <Say textColor={syllColor}>{`[['${a}${synth}-${z}]]`}</Say>,
    <Say textColor={lngColor2}>{`[['${a}${synth}-:${z}]]`}</Say>,
    <Say textColor={schwColor}>{`[['${a}@-${synth}-:${z}]]`}</Say>
  </>);
}
